import { formatDate } from '../../helpers/dateHelper';
export var getCurrentLevel = function getCurrentLevel(currentLevel, levelIncreaseStatus) {
  if (currentLevel === 1 && levelIncreaseStatus !== 'pass') {
    return 1;
  } else if (currentLevel === 1 && levelIncreaseStatus === 'pass') {
    return 2;
  } else if (currentLevel === 2) {
    return 2;
  } else if (currentLevel === 3) {
    return 3;
  } else {
    return 1;
  }
};
export var submitIdentityMindForm = function submitIdentityMindForm(props) {
  var alphaPointSessiontoken = props.alphaPointSessiontoken,
    alphaPointUserID = props.alphaPointUserID,
    _props$kycConfig = props.kycConfig,
    type = _props$kycConfig.type,
    requestIdentifier = _props$kycConfig.requestIdentifier,
    submitInfoIdentityMind = props.submitInfoIdentityMind,
    formValues = props.formValues,
    userName = props.userName,
    email = props.email,
    reset = props.reset,
    onSubmit = props.onSubmit;
  var Config = Object.keys(formValues || {}).map(function (key) {
    return {
      Key: key,
      Value: formValues[key]
    };
  });
  Config.push({
    Key: 'email',
    Value: email
  });
  var setUserConfigPayload = {
    UserId: Number(alphaPointUserID),
    UserName: userName,
    Config: Config
  };
  var dob = formValues.dob ? formatDate(formValues.dob, 'MM/DD/YYYY') : undefined;
  var userInfo = Object.assign({}, formValues, {
    accountName: alphaPointUserID,
    email: email,
    billingFlatNumber: '',
    salutation: '',
    dob: dob
  });
  var clientInfo = {
    alphaPointSessiontoken: alphaPointSessiontoken,
    alphaPointUserID: alphaPointUserID,
    validationStage: 1,
    validator: type
  };
  var validateUserRegistrationPayload = {
    requestIdentifier: requestIdentifier,
    clientInfo: clientInfo,
    userInfo: userInfo
  };
  var submitInfoIdentityMindPayload = {
    validateUserRegistrationPayload: validateUserRegistrationPayload,
    setUserConfigPayload: setUserConfigPayload
  };
  submitInfoIdentityMind(submitInfoIdentityMindPayload);
  reset();
  onSubmit && onSubmit();
};